import { BrowserRouter } from 'react-router-dom';
import { Router } from './router';
import { NotificationProvider } from './features/notifications/context/NotificationProvider';
import { AuthProvider } from './features/auth/context/AuthProvider';

export function App() {
  return (
    <BrowserRouter>
      {/*
       * Ordre important :
       * 1. BrowserRouter : requis par AuthProvider (useNavigate)
       * 2. NotificationProvider : disponible pour AuthProvider et tous ses descendants
       * 3. AuthProvider : initialise le token depuis localStorage, expose login/logout,
       *    appelle logout() via useFetch sur HTTP 401
       */}
      <NotificationProvider>
        <AuthProvider>
          <Router />
        </AuthProvider>
      </NotificationProvider>
    </BrowserRouter>
  );
}
